// Conteúdo editorial da landing page (placeholders identificados para substituição).

export interface Testimonial {
  name: string;
  company: string;
  role: string;
  photo: string;
  quote: string;
  logo: string;
}

// IMPORTANTE: ainda não há depoimentos reais cadastrados.
// Preencha esta lista com depoimentos verdadeiros quando disponíveis.
// A seção de Testimonials renderiza um estado "em breve" enquanto estiver vazia.
export const testimonials: Testimonial[] = [];

export interface InstagramPost {
  id: string;
  image: string;
  type: "image" | "video";
  alt: string;
  link: string;
  video?: string;
}

// Placeholders visuais — substituir pelo conteúdo real do @playmenu.app
// quando a integração com a API do Instagram for ativada.
export const instagramPosts: InstagramPost[] = [
  {
    id: "ig-1",
    type: "video",
    alt: "Smash Bacon da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smash%20bacon%20cheeseburger%20with%20melted%20cheddar%20cheese%20dripping%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-01&orientation=squarish",
  },
  {
    id: "ig-2",
    type: "image",
    alt: "Pizza Burrata da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    image:
      "https://readdy.ai/api/search-image?query=Artisan%20burrata%20pizza%20with%20stretchy%20cheese%20pull%20and%20fresh%20basil%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-02&orientation=squarish",
  },
  {
    id: "ig-3",
    type: "video",
    alt: "Camarão crocante da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    image:
      "https://readdy.ai/api/search-image?query=Crispy%20golden%20fried%20shrimp%20with%20dipping%20sauce%20and%20lime%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-03&orientation=squarish",
  },
  {
    id: "ig-4",
    type: "image",
    alt: "Cheesecake da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    image:
      "https://readdy.ai/api/search-image?query=Creamy%20cheesecake%20slice%20with%20berry%20compote%20being%20poured%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-04&orientation=squarish",
  },
  {
    id: "ig-5",
    type: "video",
    alt: "Caipirinha da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/680df7a4-b8da-490c-aa2c-2ce79964409f_c75dea2d101c485491e0b1f923d12a80.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Brazilian%20caipirinha%20cocktail%20with%20muddled%20lime%20wedges%20sugar%20and%20crushed%20ice%20in%20a%20short%20glass%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20drink%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-05&orientation=squarish",
  },
  {
    id: "ig-6",
    type: "image",
    alt: "Prato gourmet da PlayMenu",
    link: "https://instagram.com/playmenu.app",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20plated%20gourmet%20dish%20with%20artistic%20presentation%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=720&seq=playmenu-ig-06&orientation=squarish",
  },
];

export interface PartnerLogo {
  name: string;
  image: string;
}

// Logos de restaurantes parceiros (fundo transparente).
export const partnerLogos: PartnerLogo[] = [
  {
    name: "Buteco do Baiano",
    image:
      "https://public.readdy.ai/ai/img_res/6f8af293-a956-4caa-a22f-d6a292d8f301.png",
  },
  {
    name: "Orla",
    image:
      "https://public.readdy.ai/ai/img_res/00cc76d2-4baf-4dd8-9679-cf9c67bc3171.png",
  },
  {
    name: "Taberna da Carne",
    image:
      "https://public.readdy.ai/ai/img_res/d3ccc87b-6598-4a0d-b35c-f6430e524a2c.png",
  },
];

export interface AudienceCard {
  title: string;
  tagline: string;
  image: string;
  video?: string;
}

export const audience: AudienceCard[] = [
  {
    title: "Hamburguerias",
    tagline: "Queijo derretendo em tela cheia.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/8e4c57e7-ff6c-49a1-833c-458a361b7040_Hamburguer_sendo_partido_ao_meio_20260916164112.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Gourmet%20smash%20burger%20with%20melted%20cheese%20and%20crispy%20bacon%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail%20appetizing&width=720&height=900&seq=playmenu-aud-01&orientation=portrait",
  },
  {
    title: "Pizzarias",
    tagline: "O fio de queijo que vende sozinho.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/eb96f317-46ba-4adc-853d-558572e18d43_vdeo_20260916162917.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Artisan%20pizza%20slice%20with%20long%20stretchy%20cheese%20pull%20and%20charred%20crust%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-02&orientation=portrait",
  },
  {
    title: "Restaurantes",
    tagline: "Apresentação que valoriza cada prato.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/fb338edb-e395-43c5-ac77-15e42fa75a8c_Analyze_food_image_for_commercial_202606170139.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20plated%20fine%20dining%20dish%20with%20artistic%20sauce%20dots%20and%20garnish%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-03&orientation=portrait",
  },
  {
    title: "Bares",
    tagline: "Drinks que pedem um brinde.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/cea54360-e038-4bb0-85cf-c92d5797316a_27384dc786404380a456785cfd7f8b3f.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Craft%20cocktail%20with%20smoke%20and%20citrus%20garnish%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20drink%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-04&orientation=portrait",
  },
  {
    title: "Barracas de praia",
    tagline: "Clima de verão em cada frame.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/87d6829b-a441-4afc-816f-057c838c9675_7bc95826f61a46a098bdd03ae0179757.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Tropical%20beach%20club%20cocktail%20with%20ice%20and%20fruit%20garnish%20against%20a%20blurred%20sunset%20beach%20background%20warm%20orange%20lighting%20editorial%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-05&orientation=portrait",
  },
  {
    title: "Cafeterias",
    tagline: "O ritual do café em movimento.",
    image:
      "https://readdy.ai/api/search-image?query=Latte%20art%20coffee%20cup%20with%20steam%20rising%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20coffee%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-06&orientation=portrait",
  },
  {
    title: "Docerias",
    tagline: "Sobremesas que pedem para serem vistas.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/bd71de67-63a9-4247-b437-136c036cdaa8_19a21b5a5ce94c84b56af464b22a918f-1.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Decadent%20layered%20chocolate%20cake%20slice%20with%20glossy%20ganache%20dripping%20and%20fresh%20red%20berries%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20dessert%20photography%20cinematic%20moody%20high%20detail%20appetizing&width=720&height=900&seq=playmenu-aud-08&orientation=portrait",
  },
  {
    title: "Food Trucks",
    tagline: "Cardápio rápido, desejo imediato.",
    video:
      "https://storage.helloreaddy.io/project_files/52886a64-7fa9-42b2-a5b3-49fd386bb6d3/b1eb8693-9f6c-4561-bef6-bce94d2aee56_02e95849c9b84d1a93fe182d8fd347b1.mp4",
    image:
      "https://readdy.ai/api/search-image?query=Street%20food%20gourmet%20taco%20with%20fresh%20ingredients%20on%20a%20dark%20charcoal%20background%20warm%20orange%20rim%20lighting%20editorial%20food%20photography%20cinematic%20moody%20high%20detail&width=720&height=900&seq=playmenu-aud-07&orientation=portrait",
  },
];

export interface Plan {
  id: string;
  name: string;
  description: string;
  price: string;
  badge: string;
  billing: string;
  cta: string;
  featured: boolean;
  tag: string;
}

export const planFeatures: string[] = [
  "Cardápio em vídeo e QR Code",
  "Gestão de produtos e categorias",
  "Link público do restaurante",
];

export const plans: Plan[] = [
  {
    id: "mensal",
    name: "Mensal",
    description: "Para começar sem compromisso de longo prazo.",
    price: "147",
    badge: "Sem fidelidade",
    billing: "Cobrança mensal de R$ 147.",
    cta: "Começar no mensal",
    featured: false,
    tag: "",
  },
  {
    id: "semestral",
    name: "Semestral",
    description: "Para quem quer consistência com melhor custo mensal.",
    price: "117,60",
    badge: "20% de economia",
    billing: "R$ 705,60 por semestre.",
    cta: "Escolher semestral",
    featured: true,
    tag: "Equilíbrio ideal",
  },
  {
    id: "anual",
    name: "Anual",
    description: "Para operações consolidadas que buscam máxima economia.",
    price: "95,50",
    badge: "Aproximadamente 35% de economia",
    billing: "R$ 1146 por ano.",
    cta: "Escolher anual",
    featured: false,
    tag: "",
  },
];

export interface RepresentativeStep {
  n: string;
  title: string;
  text: string;
}

export const representativePerks: string[] = [
  "Painel exclusivo para acompanhar indicações",
  "Acompanhamento de clientes e comissões",
  "Produto visual que se explica na demonstração",
];

export const representativeSteps: RepresentativeStep[] = [
  { n: "01", title: "Indique", text: "Apresente o Play Menu." },
  { n: "02", title: "Acompanhe", text: "Veja cada etapa no painel." },
  { n: "03", title: "Cresça", text: "Gerencie clientes e comissões." },
];

export interface Capability {
  icon: string;
  title: string;
  text: string;
  tag?: string;
}

// Ecossistema do produto. Baseado nas capacidades reais da plataforma PlayMenu.
export const capabilities: Capability[] = [
  {
    icon: "ri-video-line",
    title: "Cardápio em vídeo",
    text: "Seus pratos em movimento, textura e preparo — navegação vertical como nas redes sociais.",
    tag: "O coração do Play Menu",
  },
  {
    icon: "ri-sparkling-line",
    title: "Inteligência Artificial",
    text: "Cadastro inteligente, geração e otimização de conteúdo e automação do cardápio.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Realidade Aumentada",
    text: "Novas formas de visualizar produtos e experiências, direto na mesa do cliente.",
    tag: "Diferencial",
  },
  {
    icon: "ri-links-line",
    title: "Link na Bio",
    text: "Centralize a presença digital do restaurante em um único link.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reservas",
    text: "Sistema de reservas integrado ao cardápio e à operação do restaurante.",
  },
  {
    icon: "ri-time-line",
    title: "Fila de espera",
    text: "Organize a fila do estabelecimento sem atrito para a equipe nem para o cliente.",
  },
  {
    icon: "ri-qr-code-line",
    title: "Pedidos na mesa",
    text: "QR Code por mesa. O cliente pede diretamente pelo sistema.",
  },
  {
    icon: "ri-store-2-line",
    title: "PDV e Gestão",
    text: "Ferramentas voltadas para a operação completa do restaurante.",
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

// Perguntas frequentes oficiais da PlayMenu — foco em eliminar objeções.
export const faqs: FaqItem[] = [
  {
    question: "Preciso trocar meu cardápio atual?",
    answer:
      "Não. O Play Menu complementa o que você já usa. Você cadastra seus produtos e o cardápio fica no ar — com o seu QR Code ou um novo.",
  },
  {
    question: "Preciso ter fotos profissionais?",
    answer:
      "Não. Fotos comuns já funcionam. A inteligência artificial e a edição fazem o trabalho pesado de deixar tudo com cara de vídeo profissional.",
  },
  {
    question: "Como são criados os vídeos?",
    answer:
      "Você envia a foto do prato. A IA transforma em vídeo com movimento, textura e clima — pronto para entrar no cardápio.",
  },
  {
    question: "Quanto tempo demora?",
    answer:
      "Seu cardápio fica no ar em poucos dias. Os primeiros vídeos de teste chegam rápido para você aprovar.",
  },
  {
    question: "Funciona em qualquer celular?",
    answer:
      "Sim. O cardápio abre no navegador, sem instalar nada — funciona em iOS e Android.",
  },
  {
    question: "Preciso instalar aplicativo?",
    answer:
      "Não, nem você nem o cliente. Tudo roda pelo link ou QR Code, direto no navegador.",
  },
  {
    question: "Posso utilizar meu próprio QR Code?",
    answer:
      "Sim. Você pode apontar o seu QR Code atual para o cardápio Play Menu ou gerar um novo.",
  },
  {
    question: "Posso testar antes de contratar?",
    answer:
      "Sim. Você ganha 3 vídeos gratuitos para ver seus próprios pratos em movimento antes de qualquer decisão.",
  },
  {
    question: "Como funcionam os 3 vídeos gratuitos?",
    answer:
      "Você cadastra, envia suas fotos e solicita até 3 vídeos. Sem pagamento e sem compromisso.",
  },
  {
    question: "O Play Menu também recebe pedidos?",
    answer:
      "Sim. Com o QR Code por mesa, o cliente pede direto pelo sistema, sem depender do garçom.",
  },
  {
    question: "Existe plano para redes de restaurantes?",
    answer:
      "Sim. Temos condições especiais para redes, franquias e grupos gastronômicos.",
  },
];